import { StyleFn } from '../elements/StyleFn'

/**
 * reusable focus styles
 * @param theme
 * @returns
 */
export const focus: StyleFn = (theme) => {
  const { color } = theme
  const focusColor = color.getModalValues(color.border.focus)

  const browserReset = {
    // Remove Firefox dotted outline
    '&::-moz-focus-inner': {
      borderStyle: 'none',
    },
  }

  return {
    focusDefault: {
      ...browserReset,
      border: '2px solid transparent',
      '&:focus-visible': {
        outline: 'none',
        border: `2px solid ${focusColor}`,
      },
    },
    focusWithPseudo: ({
      colorForce = '',
      pseudo = 'after',
      focusSelector = 'focus-visible',
      radius = '6px',
      offset = 4,
      width = '',
    } = {}) => ({
      ...browserReset,
      // elements with borders need spacing between focus border
      position: 'relative',
      border: '1px solid transparent',
      [`&:${focusSelector}`]: { outline: 'none' },
      [`&:${focusSelector}:${pseudo}`]: {
        content: '""',
        position: 'absolute',
        top: -offset,
        left: -offset,
        right: -offset,
        bottom: -offset,
        border: `2px solid ${colorForce !== '' ? colorForce : focusColor}`,
        borderRadius: radius,
        ...(width !== '' && { width }),
      },
    }),
  }
}
